
import { Component, Vue } from 'vue-property-decorator';
import EnterpriseMenuPull from '@/components/enterprise/EnterpriseMenuPull.vue';

@Component<EnterpriseMenuPullView>({
	components: {
		EnterpriseMenuPull
	}
})
export default class EnterpriseMenuPullView extends Vue {
}
